import { apiGet } from '../api.ts'
import { useQuery } from '@tanstack/react-query'
import { QueryCacheKeys } from '@/api/queryKeys.ts'
import { IPagingReq, IPagingRes } from '@/api/paging.ts'
import { createUrl } from '@/util/url.ts'
import { IPosition } from '@/api/user/getUsers.ts'

interface IReqGetUrgentHistory extends IPagingReq {

}

export const apiGetNotificationSos = async ({ pageNum, pageSize }: IReqGetUrgentHistory, query?: string) => {
    return await apiGet<IPagingRes<IAlertEmergency[]>>(createUrl('/alert/emergency', {
        query: query,
        pageNum: pageNum,
        pageSize: pageSize
    }))
}

const useQueryGetNotificationSos = (props: IReqGetUrgentHistory, query?: string) => {
    return useQuery({
        queryKey: [...QueryCacheKeys.notification.apiGetNotificationSos(query), props.pageNum, props.pageSize],
        queryFn: async () => {
            const { data } = await apiGetNotificationSos(props, query)
            return data
        },
        gcTime: 10 * 60 * 1000, // 10분 동안 가비지 컬렉션 방지
        staleTime: 5 * 60 * 1000 // 5분 동안 데이터를 fresh 상태로 유지
    })
}

export default useQueryGetNotificationSos

export interface IAlert {
    name: string;
    nameDetail: string | null;
    managerName: string | null;
    confirm: string;
    result: string | null;
    createdAt: string;
    checkedAt: string | null;
    location: IPosition;
    type?: string;
    isMyTask?: boolean;
    taskManagerAt?: string;
    content?: string;
}

export interface IProtectee {
    id: number;
    name: string;
    gender: string;
    birthDate: string;
    contact: string;
    memo?: string;
}

export interface IProtector {
    contact: string;
    secondaryContact?: string;
    tertiaryContact?: string;
}

export interface IAlertEmergencyAlert {
    name: string;
    nameDetail?: IAlertStateDetail;
    managerName: string;
    confirm: EmergencyAlertConfirmStatus;
    result?: any;
    content?: string;
    isMyTask?: boolean;
    taskCheckAt?: string;
    taskManagerAt?: string;
    createdAt: string;
    checkedAt?: any;
    location: IPosition;
    type?: EmergencyAlertType;
}

export interface IAlertEmergency {
    id: number;
    protectee: IProtectee;
    protector: IAlertSosProtector;
    alert: IAlertEmergencyAlert;
}

export interface IAlertSosProtector {
    relation?: string;
    contact?: string;
    secondaryRelation?: string;
    secondaryContact?: string;
    tertiaryRelation?: string;
    tertiaryContact?: string;
}

export interface IAlertStateDetail {
    resp: number;
    hrate: number;
    respStatus: string;
    hrateStatus: string;
}

export enum EmergencyAlertConfirmStatus {
    WAIT = '미처리',
    ASSIGN = '담당자 배정',
    DONE = '처리'
}

export enum EmergencyAlertType {
    SOS = 'sos',
    FALL = 'fall'
}